import WG from '../global/js/wg';

export class TrackingService {
    /**
     * trackEventForm
     * @param {object} options - Options
     * @param {boolean} enqueue - Enqueue
     * @return {Promise}
     * */
    static trackEventForm(options, enqueue = true) {
        const tracking = new WG.Tracking(options);
        return tracking.send(enqueue);
    }

    /**
     * trackAirPr
     * @param {object} options - Options
     * */
    static trackAirPr(options) {
        new WG.AirPrTracking(options);
    }
}



// WEBPACK FOOTER //
// ./node_modules/wg5/src/services/tracking.js